// Estilos del widget — Shadow DOM, sin colisión con el tema WordPress.
// La variable --asesoria-primary se inyecta desde el host.

export const widgetStyles = /* css */ `
@import url('https://fonts.googleapis.com/css2?family=Roboto:wght@400;500;600;700&display=swap');

:host {
  all: initial;
  font-family: "Roboto", -apple-system, BlinkMacSystemFont, "Segoe UI", "Helvetica Neue", Arial, sans-serif;
  color: #0f172a;
  position: fixed;
  z-index: 2147483600;
  --primary: var(--asesoria-primary, #0F2A5C);
  --primary-hover: var(--asesoria-primary-hover, #08193E);
  --primary-text: #ffffff;
  /* Verde tipo WhatsApp solo para la burbuja + CTA (llamar la atención). */
  --attention: #25D366;
  --attention-hover: #1eb955;
  --bg: #ffffff;
  --muted: #69727d;
  --user-bubble: var(--primary);
  --user-text: #ffffff;
  --bot-bubble: #f1f5f9;
  --bot-text: #1d1d1b;
  --shadow: 0 10px 30px rgba(15, 23, 42, 0.18);
  --radius: 14px;
  font-size: 14px;
  line-height: 1.45;
}

.widget-root.position-bottom-right { right: 16px; bottom: 16px; }
.widget-root.position-bottom-left { left: 16px; bottom: 16px; }
.widget-root { position: fixed; }

.bubble {
  width: 60px;
  height: 60px;
  border-radius: 50%;
  background: var(--attention);
  color: var(--primary-text);
  cursor: pointer;
  display: flex; align-items: center; justify-content: center;
  box-shadow: var(--shadow);
  border: none;
  position: relative;
  z-index: 2;
  transition: transform 0.15s ease, background 0.2s ease;
}
.bubble:hover { background: var(--attention-hover); transform: scale(1.05); }
.bubble:focus { outline: 3px solid rgba(15, 42, 92, 0.4); outline-offset: 2px; }
.bubble.is-open { background: var(--primary-hover); }
.bubble svg { width: 28px; height: 28px; animation: icon-pop 0.25s ease-out; }

/* === Llamada de atención de la burbuja === */
/* Halo "radar" que pulsa continuamente alrededor de la burbuja. */
.bubble::after {
  content: '';
  position: absolute; inset: 0;
  border-radius: 50%;
  background: var(--attention);
  z-index: -1;
  animation: ping 1.9s cubic-bezier(0, 0, 0.2, 1) infinite;
}
.bubble.is-open::after { animation: none; opacity: 0; }
@keyframes ping {
  0% { transform: scale(1); opacity: 0.55; }
  70%, 100% { transform: scale(1.9); opacity: 0; }
}
/* Meneo amplio cada ~4s para captar la mirada. */
.bubble:not(.is-open) { animation: attention 4s ease-in-out 1.5s infinite; }
.bubble:not(.is-open):hover { animation-play-state: paused; }
@keyframes attention {
  0%, 65%, 100% { transform: none; }
  70% { transform: scale(1.15) rotate(-12deg); }
  76% { transform: scale(1.12) rotate(12deg); }
  82% { transform: scale(1.15) rotate(-9deg); }
  88% { transform: scale(1.1) rotate(7deg); }
  94% { transform: scale(1.05) rotate(0); }
}

/* CTA de texto (bocadillo) — color de marca, vivo, con rebote periódico. */
.cta-label {
  position: absolute;
  bottom: 14px; right: 76px;
  background: var(--attention);
  color: #ffffff;
  font-size: 14px; font-weight: 700; line-height: 1.25;
  padding: 11px 34px 11px 16px;
  border-radius: 16px;
  box-shadow: 0 10px 28px rgba(15, 23, 42, 0.30);
  white-space: nowrap;
  cursor: pointer;
  z-index: 1;
  animation: cta-in 0.45s ease-out 0.8s both, cta-bounce 2.6s ease-in-out 2s infinite;
}
.widget-root.position-bottom-left .cta-label { right: auto; left: 76px; }
.cta-label::after {
  content: ''; position: absolute;
  right: -7px; top: 50%; width: 0; height: 0;
  transform: translateY(-50%);
  border-left: 8px solid var(--attention);
  border-top: 7px solid transparent; border-bottom: 7px solid transparent;
}
.widget-root.position-bottom-left .cta-label::after {
  right: auto; left: -7px;
  border-left: 0; border-right: 8px solid var(--attention);
}
.cta-close {
  position: absolute; top: 4px; right: 7px;
  width: 18px; height: 18px;
  border: none; background: transparent;
  color: rgba(255, 255, 255, 0.7); font-size: 16px; line-height: 1; padding: 0;
  display: flex; align-items: center; justify-content: center;
  border-radius: 50%; cursor: pointer;
}
.cta-close:hover { background: rgba(255, 255, 255, 0.22); color: #ffffff; }
.cta-label.cta-hidden { display: none; }
@keyframes cta-in {
  from { opacity: 0; transform: translateX(12px) scale(0.9); }
  to { opacity: 1; transform: none; }
}
@keyframes cta-bounce {
  0%, 55%, 100% { transform: none; }
  65% { transform: translateX(-5px); }
  75% { transform: translateX(3px); }
  85% { transform: translateX(-2px); }
}
@keyframes icon-pop {
  from { opacity: 0; transform: rotate(-90deg) scale(0.6); }
  to { opacity: 1; transform: none; }
}

.panel {
  width: 380px;
  max-width: calc(100vw - 32px);
  height: 600px;
  max-height: calc(100vh - 110px);
  background: var(--bg);
  border-radius: var(--radius);
  box-shadow: var(--shadow);
  overflow: hidden;
  display: flex;
  flex-direction: column;
  border: 1px solid rgba(15, 23, 42, 0.08);
  position: absolute;
  bottom: 76px;
  right: 0;
  z-index: 1;
  animation: pop 0.18s ease-out;
}
.widget-root.position-bottom-left .panel { right: auto; left: 0; }
@keyframes pop { from { opacity: 0; transform: translateY(8px) scale(0.98);} to {opacity:1; transform: none;} }

.header {
  background: linear-gradient(135deg, var(--primary) 0%, var(--primary-hover) 100%);
  color: var(--primary-text);
  padding: 14px 16px;
  display: flex; align-items: center; gap: 12px;
  box-shadow: 0 2px 10px rgba(15, 23, 42, 0.12);
}
.header .avatar {
  width: 38px; height: 38px; border-radius: 50%;
  background: #ffffff;
  display: flex; align-items: center; justify-content: center;
  overflow: hidden;
  flex-shrink: 0;
}
.header .avatar img {
  max-width: 62%; max-height: 62%; object-fit: contain;
}
.header .titles { flex: 1; min-width: 0; }
.header .name { font-weight: 600; font-size: 14px; }
.header .status {
  font-size: 11.5px;
  line-height: 1.25;
  opacity: 0.9;
  display: flex; align-items: center; gap: 6px;
}
.header .status-dot {
  width: 7px; height: 7px;
  border-radius: 50%;
  background: #22c55e;
  flex-shrink: 0;
  box-shadow: 0 0 0 0 rgba(34, 197, 94, 0.6);
  animation: pulse-dot 2s infinite;
}
@keyframes pulse-dot {
  0% { box-shadow: 0 0 0 0 rgba(34, 197, 94, 0.6); }
  70% { box-shadow: 0 0 0 6px rgba(34, 197, 94, 0); }
  100% { box-shadow: 0 0 0 0 rgba(34, 197, 94, 0); }
}
.header button {
  background: transparent; border: none; color: var(--primary-text);
  cursor: pointer; padding: 6px; border-radius: 6px;
  display: flex; align-items: center; justify-content: center;
  transition: background 0.15s ease;
}
.header button:hover { background: rgba(255,255,255,0.16); }

.disclaimer {
  font-size: 11px;
  background: #f8fafc;
  color: #475569;
  padding: 8px 14px;
  border-bottom: 1px solid #e2e8f0;
  line-height: 1.4;
}

.messages {
  flex: 1; min-height: 0; overflow-y: auto; padding: 14px 12px;
  display: flex; flex-direction: column; gap: 10px;
  background: #fafafa;
}
.messages::-webkit-scrollbar { width: 8px; }
.messages::-webkit-scrollbar-thumb { background: #cbd5e1; border-radius: 4px; }
.messages::-webkit-scrollbar-track { background: transparent; }

.msg {
  display: flex; flex-direction: column; max-width: 88%;
  animation: msg-in 0.28s ease-out both;
}
.msg.user { align-self: flex-end; align-items: flex-end; }
.msg.bot { align-self: flex-start; align-items: flex-start; }
.bubble-msg {
  padding: 10px 12px; border-radius: 14px;
  white-space: pre-wrap; word-wrap: break-word;
  font-size: 14px; line-height: 1.45;
}
.msg.user .bubble-msg { background: var(--user-bubble); color: var(--user-text); border-bottom-right-radius: 4px; }
.msg.bot .bubble-msg { background: var(--bot-bubble); color: var(--bot-text); border-bottom-left-radius: 4px; }
.msg-time { font-size: 10px; color: var(--muted); margin-top: 3px; }
@keyframes msg-in {
  from { opacity: 0; transform: translateY(8px); }
  to { opacity: 1; transform: none; }
}

.typing {
  align-self: flex-start;
  background: var(--bot-bubble); color: var(--muted);
  padding: 10px 14px; border-radius: 14px; border-bottom-left-radius: 4px;
  display: flex; gap: 4px;
}
.typing span {
  width: 6px; height: 6px; border-radius: 50%; background: var(--muted);
  animation: blink 1.2s infinite ease-in-out both;
}
.typing span:nth-child(2) { animation-delay: 0.2s; }
.typing span:nth-child(3) { animation-delay: 0.4s; }
@keyframes blink { 0%, 80%, 100% { opacity: 0.2; transform: scale(0.8); } 40% { opacity: 1; transform: scale(1); } }

.quick-replies, .options {
  display: flex; flex-wrap: wrap; gap: 6px; padding: 0 12px 8px 12px;
}
.chip {
  border: 1px solid rgba(15, 23, 42, 0.12);
  background: #fff;
  color: #1d1d1b;
  border-radius: 16px;
  padding: 7px 13px;
  font: inherit;
  font-size: 13px;
  cursor: pointer;
  transition: background 0.15s ease, border-color 0.15s ease, transform 0.12s ease, box-shadow 0.15s ease, color 0.15s ease;
}
.chip:hover {
  border-color: var(--primary);
  background: #fff;
  color: var(--primary);
  transform: translateY(-1px);
  box-shadow: 0 3px 10px rgba(15, 42, 92, 0.12);
}
.chip.primary { background: var(--primary); color: var(--primary-text); border-color: transparent; }
.chip.primary:hover { background: var(--primary-hover); color: var(--primary-text); }

.slots {
  display: flex; flex-direction: column; gap: 6px; padding: 4px 12px 10px 12px;
}
.slot {
  text-align: left;
  border: 1px solid rgba(15, 23, 42, 0.12);
  background: #fff;
  border-radius: 10px;
  padding: 10px 12px;
  font: inherit;
  font-size: 13px;
  cursor: pointer;
  transition: border-color 0.15s ease, box-shadow 0.15s ease, transform 0.12s ease;
}
.slot:hover {
  border-color: var(--primary);
  box-shadow: 0 3px 10px rgba(15, 42, 92, 0.12);
  transform: translateY(-1px);
}

.cited-sources {
  font-size: 11px; color: var(--muted); padding: 0 12px 6px 12px;
}
.cited-sources a { color: var(--muted); text-decoration: underline; }

.composer {
  display: flex; gap: 8px; padding: 10px;
  border-top: 1px solid rgba(15, 23, 42, 0.08);
  background: #fff;
}
textarea {
  flex: 1; resize: none; border: 1px solid rgba(15, 23, 42, 0.12);
  border-radius: 10px; padding: 10px; font: inherit;
  max-height: 120px;
  color: #1d1d1b;
}
textarea:focus { outline: 2px solid var(--primary); outline-offset: 0; border-color: transparent; }
.composer textarea:disabled {
  background: #f1f5f9; color: var(--muted); cursor: not-allowed;
}
.send-btn {
  background: var(--primary); color: var(--primary-text);
  border: none; border-radius: 10px; padding: 0 14px; cursor: pointer;
  font: inherit; font-weight: 600;
  transition: background 0.15s ease;
}
.send-btn:hover:not(:disabled) { background: var(--primary-hover); }
.send-btn:disabled { opacity: 0.5; cursor: not-allowed; }

.footer-meta {
  font-size: 10px; color: var(--muted); text-align: center; padding: 6px 12px 8px 12px;
  background: #fff;
}
.footer-meta a {
  color: var(--asesoria-primary, #0F2A5C); text-decoration: underline; font-weight: 600;
}

.error-banner {
  background: #fef2f2; color: #991b1b; padding: 8px 12px; font-size: 12px;
  border-bottom: 1px solid #fecaca;
}

.honeypot {
  position: absolute; left: -9999px; top: -9999px; width: 1px; height: 1px;
  opacity: 0;
}

.lead-form {
  display: flex; flex-direction: column; gap: 8px;
  margin: 0 12px 10px 12px;
  padding: 12px;
  background: #fff;
  border: 1px solid rgba(15, 23, 42, 0.12);
  border-radius: 12px;
}
.lead-form-row { display: flex; flex-direction: column; gap: 4px; }
.lead-form-row label {
  font-size: 12px; font-weight: 500; color: var(--muted);
}
.lead-form-row input {
  border: 1px solid rgba(15, 23, 42, 0.12);
  border-radius: 8px;
  padding: 8px 10px;
  font: inherit;
  font-size: 13px;
}
.lead-form-row input:focus {
  outline: 2px solid var(--primary); outline-offset: 0; border-color: transparent;
}
.lead-form-consent {
  display: flex; align-items: flex-start; gap: 6px;
  font-size: 11px; color: var(--muted);
  margin-top: 4px;
}
.lead-form-consent input[type="checkbox"] {
  margin-top: 2px;
  accent-color: var(--primary);
}
.lead-form-consent a { color: var(--primary); text-decoration: underline; }
.lead-form-submit { margin-top: 4px; padding: 8px 12px; }
.lead-form-error {
  font-size: 12px; color: #b91c1c; min-height: 1em;
}

.conversation-end {
  margin: 4px 12px 12px 12px;
  padding: 18px 16px;
  background: #ecfdf5;
  border: 1px solid #a7f3d0;
  border-radius: 12px;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 10px;
  text-align: center;
}
.conversation-end-icon {
  width: 40px; height: 40px; border-radius: 50%;
  background: #10b981; color: #fff;
  display: flex; align-items: center; justify-content: center;
  font-size: 22px; font-weight: 700; line-height: 1;
}
.conversation-end-text {
  font-size: 14px; font-weight: 500; color: #065f46;
  line-height: 1.4;
}
.conversation-end .restart-btn {
  width: 100%;
  padding: 10px 14px;
  margin-top: 4px;
  font-size: 14px;
}

@media (prefers-reduced-motion: reduce) {
  .panel, .msg { animation: none !important; }
  .header .status-dot { animation: none !important; }
  .typing span { animation: none !important; opacity: 0.6; }
  .bubble svg { animation: none !important; }
  .bubble:not(.is-open) { animation: none !important; }
  .bubble::after { animation: none !important; opacity: 0 !important; }
  .cta-label { animation: none !important; opacity: 1; }
  .bubble:hover, .chip:hover, .slot:hover { transform: none !important; }
}

@media (max-width: 480px) {
  /* iOS Safari: 100vh NO descuenta la barra del navegador ni el teclado, así que
     el composer quedaba fuera de pantalla al escribir. Usamos 100dvh (viewport
     dinámico) con fallback a 100vh, anclando solo arriba (top:0 + bottom:auto)
     para que al subir el teclado el panel encoja y el input quede visible. */
  .panel {
    width: 100vw; max-width: 100vw;
    right: 0; left: 0; top: 0; bottom: auto;
    height: 100vh;
    height: 100dvh;
    max-height: 100vh;
    max-height: 100dvh;
    border-radius: 0;
    border: none;
    position: fixed;
  }
  .widget-root.position-bottom-right .panel,
  .widget-root.position-bottom-left .panel {
    width: 100vw;
    max-width: 100vw;
  }
  /* Safe areas (notch / home indicator) + font-size 16 evita el auto-zoom de iOS. */
  .header { padding-top: calc(14px + env(safe-area-inset-top, 0px)); }
  .composer { padding-bottom: calc(10px + env(safe-area-inset-bottom, 0px)); }
  .composer textarea { font-size: 16px; }
  .header .reset-btn { display: none; }
  .bubble.is-open {
    position: fixed;
    top: calc(env(safe-area-inset-top, 0px) + 14px);
    right: 14px;
    bottom: auto;
    left: auto;
    width: 40px;
    height: 40px;
    box-shadow: none;
    background: transparent;
    color: var(--primary-text);
  }
  .bubble.is-open:hover { background: rgba(255,255,255,0.18); transform: none; }
  .bubble.is-open svg { width: 26px; height: 26px; }
}
`;
